export default __webpack_public_path__ + "static/light-node@2x-f1474c4fb3c5551636839aee945e836e.png";